var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.$auth.ready())?[_c('router-view')]:_vm._e(),(!_vm.$auth.ready())?void 0:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }